/* ELORA CARE — elora-pdp: gallery + option cards. Scoped to the section root, idempotent, re-runs on
   shopify:section:load, releases listeners on unload. The selected card feeds the price row, the button
   and the sticky bar (Liquid money in data-*, mirrored as `elora:selection`). */
window.Elora = window.Elora || {};

(function () {
  var NS = window.Elora;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function listen(el, type, handler, options, cleanups) {
    el.addEventListener(type, handler, options);
    cleanups.push(function () { el.removeEventListener(type, handler, options); });
  }

  /* Liquid indicator (BYQ gem gooey-nav-01); current() = the tab the pill rests under. */
  function makeGoo(list, tabs, current, cleanups) {
    var goo = list.querySelector('.pdp__fgoo');
    var blob = list.querySelector('.pdp__fblob');
    var drop = list.querySelector('.pdp__fdrop');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var settleTimer = null;
    var raf = 0;

    function moveTo(tab, animate) {
      if (!goo || !blob || !drop || !tab) return;
      var gr = goo.getBoundingClientRect();
      var r = tab.getBoundingClientRect();
      if (!r.width) return;
      var x = r.left - gr.left;
      var y = r.top - gr.top;
      blob.style.setProperty('--x', x + 'px');
      blob.style.setProperty('--y', y + 'px');
      blob.style.setProperty('--w', r.width + 'px');
      blob.style.setProperty('--h', r.height + 'px');
      for (var i = 0; i < tabs.length; i++) tabs[i].classList.toggle('is-under', tabs[i] === tab);
      window.clearTimeout(settleTimer);
      drop.style.setProperty('--dx', x + r.width / 2 + 'px');
      drop.style.setProperty('--dy', y + r.height / 2 + 'px');
      if (animate && !reduce.matches) {
        drop.style.setProperty('--ds', '1');
        settleTimer = window.setTimeout(function () {
          drop.style.setProperty('--ds', '0');
        }, 260);
      } else {
        drop.style.setProperty('--ds', '0');
      }
    }
    function settle(animate) {
      moveTo(current(), animate);
    }
    for (var t = 0; t < tabs.length; t++) {
      listen(tabs[t], 'mouseenter', function () { moveTo(this, true); }, false, cleanups);
      listen(tabs[t], 'focus', function () { moveTo(this, true); }, false, cleanups);
    }
    if (goo && blob && drop) {
      /* first placement without a grow-in */
      window.requestAnimationFrame(function () {
        blob.style.transition = 'none';
        settle(false);
        blob.getBoundingClientRect();
        blob.style.transition = '';
        list.classList.add('is-goo');
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { settle(false); });
      }
      var onResize = function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () { raf = 0; settle(false); });
      };
      window.addEventListener('resize', onResize, { passive: true });
      cleanups.push(function () { window.removeEventListener('resize', onResize); window.clearTimeout(settleTimer); });
      listen(list, 'mouseleave', function () { settle(true); }, false, cleanups);
    }
    return { moveTo: moveTo, settle: settle };
  }

  function initGallery(root, cleanups) {
    var track = root.querySelector('[data-ptrack]');
    var thumbBox = root.querySelector('[data-pthumbs]');
    if (!track) return;

    var stage = track.parentElement;
    var slides = track.children;
    var n = slides.length;
    var i = 0;
    var prev = root.querySelector('[data-pprev]');
    var next = root.querySelector('[data-pnext]');

    if (n <= 1) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    var thumbs = thumbBox ? Array.prototype.slice.call(thumbBox.querySelectorAll('.pdp__thumb')) : [];
    /* LP only (data-hm-glp): swipes/arrows continue through all categories; the counter stays local to the active tab. */
    var lp = !!root.querySelector('[data-hm-glp]');
    var count = root.querySelector('[data-pgcount]');

    /* Gallery tabs (Kamil 06.09): slides carry data-g; a tab jumps to its group's first slide. */
    var groups = Array.prototype.map.call(slides, function (s) { return s.getAttribute('data-g') || 'product'; });
    var tabBox = root.querySelector('[data-pgtabs]');
    var gtabs = tabBox ? Array.prototype.slice.call(tabBox.querySelectorAll('.pdp__gtab')) : [];
    var curG = groups[0];
    function tabOf(g) {
      for (var a = 0; a < gtabs.length; a++) if (gtabs[a].getAttribute('data-g') === g) return gtabs[a];
      return null;
    }
    function firstOf(g) {
      for (var a = 0; a < n; a++) if (groups[a] === g) return a;
      return 0;
    }
    function rangeOf(g) {
      var s = -1, e = -1;
      for (var a = 0; a < n; a++) if (groups[a] === g) { if (s < 0) s = a; e = a; }
      return { start: s < 0 ? 0 : s, end: e < 0 ? n - 1 : e };
    }
    /* LP stops only at the ends of the whole gallery; legacy pages keep their wrap-around. */
    function step(d) {
      if (!lp) { go(i + d); return; }
      var x = i + d;
      if (x < 0 || x >= n) return;
      go(x);
    }
    var goo = tabBox ? makeGoo(tabBox, gtabs, function () { return tabOf(curG); }, cleanups) : null;
    function setGroup(g) {
      var changed = g !== curG;
      curG = g;
      for (var a = 0; a < gtabs.length; a++) {
        var on = gtabs[a].getAttribute('data-g') === g;
        gtabs[a].setAttribute('aria-selected', on ? 'true' : 'false');
        gtabs[a].setAttribute('tabindex', on ? '0' : '-1');
      }
      for (var b = 0; b < thumbs.length; b++) thumbs[b].hidden = (thumbs[b].getAttribute('data-g') || 'product') !== g;
      if (goo && changed) goo.settle(true);
      if (lp && tabBox && changed) {
        /* the tab bar may scroll sideways on narrow phones: keep the active tab in view */
        var tb = tabOf(g);
        if (tb && tabBox.scrollWidth > tabBox.clientWidth + 2) {
          var tl = tb.offsetLeft - (tabBox.clientWidth - tb.offsetWidth) / 2;
          if (typeof tabBox.scrollTo === 'function') tabBox.scrollTo({ left: tl, behavior: reducedMotion() ? 'auto' : 'smooth' });
          else tabBox.scrollLeft = tl;
          if (goo) window.setTimeout(function () { goo.settle(false); }, reducedMotion() ? 0 : 320);
        }
      }
    }
    /* attach a neighbouring clip */
    function attachNear(x) {
      if (!NS.attachVideo) return;
      for (var a = x - 1; a <= x + 1; a++) {
        var v = slides[(a + n) % n].querySelector('video[data-src]');
        if (v) NS.attachVideo(v);
      }
    }

    /* phones: first slide flush left, others centred, last flush right */
    function offsetFor(x) {
      var w = slides[0].getBoundingClientRect().width;
      var g = parseFloat(getComputedStyle(slides[0]).marginRight) || 0;
      var sw = stage.clientWidth;
      var trackW = n * w + (n - 1) * g;
      var pos = x * (w + g) - (x > 0 ? (sw - w) / 2 : 0);
      return Math.max(0, Math.min(pos, Math.max(0, trackW - sw)));
    }

    function go(x) {
      if (lp && x0 !== null) resetSwipe();
      i = (x + n) % n;
      track.style.transform = 'translateX(' + -offsetFor(i) + 'px)';
      for (var b = 0; b < thumbs.length; b++) {
        thumbs[b].classList.toggle('is-on', b === i);
        thumbs[b].setAttribute('aria-selected', b === i ? 'true' : 'false');
      }
      setGroup(groups[i]);
      attachNear(i);
      if (lp) {
        var r = rangeOf(groups[i]);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === n - 1;
        if (count) {
          count.textContent = (i - r.start + 1) + ' / ' + (r.end - r.start + 1);
          count.hidden = false;
        }
      }
      if (thumbBox && thumbs[i]) {
        var t = thumbs[i];
        var left = t.offsetLeft - (thumbBox.clientWidth - t.offsetWidth) / 2;
        if (typeof thumbBox.scrollTo === 'function') thumbBox.scrollTo({ left: left, behavior: reducedMotion() ? 'auto' : 'smooth' });
        else thumbBox.scrollLeft = left;
      }
    }
    if (tabBox) {
      listen(tabBox, 'click', function (e) {
        var t = e.target.closest('.pdp__gtab');
        if (t) go(firstOf(t.getAttribute('data-g')));
      }, false, cleanups);
      listen(tabBox, 'keydown', function (e) {
        var t = e.target.closest('.pdp__gtab');
        if (!t) return;
        var j = gtabs.indexOf(t);
        var m = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') m = (j + 1) % gtabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') m = (j - 1 + gtabs.length) % gtabs.length;
        else if (e.key === 'Home') m = 0;
        else if (e.key === 'End') m = gtabs.length - 1;
        if (m === null) return;
        e.preventDefault();
        go(firstOf(gtabs[m].getAttribute('data-g')));
        gtabs[m].focus();
      }, false, cleanups);
    }
    /* pause / play button on video slides */
    listen(track, 'click', function (e) {
      var b = e.target.closest('[data-pvtoggle]');
      if (!b) return;
      var v = b.parentElement.querySelector('video');
      if (!v) return;
      if (v.paused) {
        v.dataset.userPaused = '0';
        if (NS.attachVideo) NS.attachVideo(v);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.dataset.userPaused = '1';
        v.pause();
      }
    }, false, cleanups);
    function syncBtn(e) {
      var v = e.target;
      var b = v.parentElement && v.parentElement.querySelector('[data-pvtoggle]');
      if (!b) return;
      b.classList.toggle('is-paused', v.paused);
      b.setAttribute('aria-pressed', v.paused ? 'true' : 'false');
      b.setAttribute('aria-label', v.paused ? b.dataset.play : b.dataset.pause);
    }
    listen(track, 'play', syncBtn, true, cleanups);
    listen(track, 'pause', syncBtn, true, cleanups);

    if (prev) listen(prev, 'click', function () { step(-1); }, false, cleanups);
    if (next) listen(next, 'click', function () { step(1); }, false, cleanups);
    if (thumbBox) {
      listen(thumbBox, 'click', function (e) {
        var t = e.target.closest('.pdp__thumb');
        if (t) go(parseInt(t.dataset.k, 10));
      }, false, cleanups);
    }

    /* LP: claim only horizontal intent, track the finger on X, then snap at most one slide. Vertical gestures and
       pinch zoom stay native. If the browser cancels/takes over, discard the preview rather than committing a swipe. */
    /* Keep LP listeners on the stationary viewport: the translated track's own hit region leaves the visible stage. */
    var swipeSurface = lp ? stage : track;
    var x0 = null, y0 = null, touchId = null, axis = null, dragBase = 0, dragMin = 0, dragMax = 0;
    function resetSwipe() {
      if (lp && track.classList.contains('is-dragging')) {
        track.classList.remove('is-dragging');
        track.style.transform = 'translateX(' + -offsetFor(i) + 'px)';
      }
      x0 = y0 = touchId = axis = null;
    }
    function touchOf(list) {
      for (var a = 0; a < list.length; a++) if (list[a].identifier === touchId) return list[a];
      return null;
    }
    listen(swipeSurface, 'touchstart', function (e) {
      if (lp && e.target.closest('button, a, input, select, textarea')) { resetSwipe(); return; }
      if (e.touches.length > 1) {
        if (lp) resetSwipe();
        else axis = 'none';
        return;
      }
      var t = e.touches[0];
      x0 = t.clientX; y0 = t.clientY; touchId = t.identifier; axis = null;
    }, { passive: true, capture: lp }, cleanups);
    listen(swipeSurface, 'touchmove', function (e) {
      if (!lp || x0 === null || axis === 'y') return;
      if (e.touches.length !== 1) { resetSwipe(); return; }
      var t = touchOf(e.touches);
      if (!t) { resetSwipe(); return; }
      var dx = t.clientX - x0, dy = t.clientY - y0;
      if (axis === null) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 10) return;
        axis = Math.abs(dx) >= Math.abs(dy) * 1.25 ? 'x' : 'y';
        if (axis === 'y') return;
        /* Continue from the painted position if a fresh swipe interrupts the previous slide transition. */
        var matrix = getComputedStyle(track).transform.match(/^matrix(3d)?\((.+)\)$/);
        dragBase = matrix ? -parseFloat(matrix[2].split(',')[matrix[1] ? 12 : 4]) : offsetFor(i);
        dragMin = offsetFor(Math.max(0, i - 1));
        dragMax = offsetFor(Math.min(n - 1, i + 1));
      }
      if (!e.cancelable) { resetSwipe(); return; }
      e.preventDefault();
      track.classList.add('is-dragging');
      var pos = Math.max(dragMin, Math.min(dragBase - dx, dragMax));
      track.style.transform = 'translateX(' + -pos + 'px)';
    }, { passive: !lp, capture: lp }, cleanups);
    listen(swipeSurface, 'touchend', function (e) {
      if (x0 === null) return;
      var t = lp ? touchOf(e.changedTouches) : e.changedTouches[0];
      if (!t || (lp && e.touches.length)) { resetSwipe(); return; }
      var dx = t.clientX - x0;
      var ok = !lp || axis === 'x';
      resetSwipe();
      if (ok && Math.abs(dx) > 45) step(dx < 0 ? 1 : -1);
    }, { passive: true, capture: lp }, cleanups);
    listen(swipeSurface, 'touchcancel', resetSwipe, { passive: true, capture: lp }, cleanups);
    cleanups.push(resetSwipe);

    var raf = 0;
    var onResize = function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () { go(i); });
    };
    window.addEventListener('resize', onResize);
    cleanups.push(function () { window.removeEventListener('resize', onResize); if (raf) window.cancelAnimationFrame(raf); });

    go(0);
  }

  /* Kamil 05.09 (Oddit rec. 7): the spec line packs items into frames that fit, rotates them every 3.2 s. */
  function initSpecline(root, cleanups) {
    var box = root.querySelector('[data-pspecline]');
    if (!box || box.classList.contains('is-static')) return; /* static line (Kamil 06.09) */
    var items = Array.prototype.map.call(box.querySelectorAll('.pdp__specline-i'), function (el) { return el.textContent; });
    if (items.length < 2) return;
    if (reducedMotion()) {
      box.classList.add('is-wrap');
      return;
    }
    var frames = [], k = 0, timer = null, lastW = -1, raf = null;

    function frame(list, on, probe) {
      var f = document.createElement('span');
      f.className = 'pdp__specline-f' + (on ? ' is-on' : '') + (probe ? ' pdp__specline-probe' : '');
      if (!probe) f.setAttribute('aria-hidden', on ? 'false' : 'true');
      for (var n = 0; n < list.length; n++) {
        var sp = document.createElement('span');
        sp.className = 'pdp__specline-i';
        sp.textContent = list[n];
        f.appendChild(sp);
      }
      return f;
    }
    function width(el) { return el.getBoundingClientRect().width; }
    function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); }
    function build(force) {
      var w = box.clientWidth;
      if (!w || (w === lastW && !force)) return;
      lastW = w;
      if (timer) { clearInterval(timer); timer = null; }
      box.classList.remove('is-rot');
      clear(box);
      var probe = frame(items, false, true);
      probe.style.cssText = 'position:absolute;left:0;top:0;visibility:hidden;white-space:nowrap;';
      box.appendChild(probe);
      var widths = Array.prototype.map.call(probe.querySelectorAll('.pdp__specline-i'), width);
      var pair = frame(items.slice(0, 2), false, false);
      pair.style.cssText = probe.style.cssText;
      box.appendChild(pair);
      var sep = Math.max(0, width(pair) - widths[0] - widths[1]);
      clear(box);
      var packs = [], cur = [], curW = 0;
      for (var m = 0; m < items.length; m++) {
        var need = cur.length ? curW + sep + widths[m] : widths[m];
        if (cur.length && need > w + 0.5) { packs.push(cur); cur = [items[m]]; curW = widths[m]; }
        else { cur.push(items[m]); curW = need; }
      }
      packs.push(cur);
      frames = []; k = 0;
      for (var p = 0; p < packs.length; p++) {
        var f = frame(packs[p], p === 0, false);
        frames.push(f);
        box.appendChild(f);
      }
      if (packs.length > 1) {
        box.classList.add('is-rot');
        timer = window.setInterval(step, 3200);
      }
    }
    function step() {
      if (document.hidden || frames.length < 2) return;
      var cur = frames[k];
      k = (k + 1) % frames.length;
      var nxt = frames[k];
      cur.classList.remove('is-on');
      cur.classList.add('is-out');
      cur.setAttribute('aria-hidden', 'true');
      nxt.classList.remove('is-out');
      void nxt.offsetWidth;
      nxt.classList.add('is-on');
      nxt.setAttribute('aria-hidden', 'false');
      window.setTimeout(function () { cur.classList.remove('is-out'); }, 650);
    }
    build(false);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { build(true); });
    var onResize = function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () { build(false); });
    };
    window.addEventListener('resize', onResize);
    cleanups.push(function () { window.removeEventListener('resize', onResize); if (timer) clearInterval(timer); if (raf) window.cancelAnimationFrame(raf); });
  }

  function initOptions(root, cleanups) {
    var opts = root.querySelectorAll('.pdp__opt');
    if (!opts.length) return;
    var qb = root.querySelector('[data-qb]');
    var blob = qb ? qb.querySelector('.pdp__optblob') : null;
    var priceEl = root.querySelector('.pdp__pricerow .pdp__price');
    var oldEl = root.querySelector('.pdp__pricerow .pdp__old');
    var badgeEl = root.querySelector('.pdp__pricerow .pdp__save');
    var atcBtn = root.querySelector('.pdp__atc');
    var atcLabel = atcBtn ? atcBtn.querySelector(':scope > span:first-child') : null;
    var atcPrice = root.querySelector('.pdp__atcp span');
    var atcOld = root.querySelector('.pdp__atcp s');

    function placeBlob(card) {
      if (!blob || !card) return;
      blob.style.top = card.offsetTop + 'px';
      blob.style.height = card.offsetHeight + 'px';
      blob.style.left = card.offsetLeft + 'px';
      blob.style.width = card.offsetWidth + 'px';
    }
    function settleBlob() {
      if (!blob) return;
      blob.style.transition = 'none';
      placeBlob(qb.querySelector('.pdp__opt.is-on'));
      window.requestAnimationFrame(function () { blob.style.transition = ''; });
    }
    function selectionOf(card) {
      var input = card.querySelector('.pdp__optin');
      return {
        variantId: input ? input.value : null,
        qty: card.getAttribute('data-qty') || '1',
        price: card.getAttribute('data-price') || '',
        compare: card.getAttribute('data-compare') || '',
        badge: card.getAttribute('data-badge') || '',
        title: card.getAttribute('data-title') || '',
        note: card.hasAttribute('data-note') ? card.getAttribute('data-note') : null,
        available: card.getAttribute('data-available') !== 'false'
      };
    }
    function swapMoney(card) {
      // price row, button and sticky bar follow the selected card (data-* = live Liquid money)
      if (!card || !card.hasAttribute('data-price')) return;
      var sel = selectionOf(card);
      if (priceEl) priceEl.textContent = sel.price;
      if (oldEl) { oldEl.textContent = sel.compare; oldEl.hidden = !sel.compare; }
      if (badgeEl) { badgeEl.textContent = sel.badge; badgeEl.hidden = !sel.badge; }
      if (atcPrice) atcPrice.textContent = sel.price;
      if (atcOld) { atcOld.textContent = sel.compare; atcOld.hidden = !sel.compare; }
      if (atcBtn) {
        atcBtn.disabled = !sel.available;
        if (atcLabel) atcLabel.textContent = sel.available ? (atcBtn.dataset.labelAdd || atcLabel.textContent) : (atcBtn.dataset.labelSoldOut || atcLabel.textContent);
      }
      var note = root.querySelector('[data-qb-note]');
      if (note && sel.note !== null) note.textContent = sel.note;
      /* Noom port (quantity tiles): the hidden quantity field follows the selected card (data-qty; 1 for the single card) */
      var qty = root.querySelector('[data-qb-qty]');
      if (qty && card.hasAttribute('data-qty')) qty.value = card.getAttribute('data-qty') || '1';
      var chip = card.querySelector('[data-qb-chip]');
      if (chip) { chip.classList.remove('is-pop'); void chip.offsetWidth; chip.classList.add('is-pop'); }
      NS.selection = sel;
      document.dispatchEvent(new CustomEvent('elora:selection', { detail: sel }));
    }
    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.classList || !input.classList.contains('pdp__optin')) return;
      var current = null;
      for (var j = 0; j < opts.length; j++) {
        var on = opts[j].contains(input);
        opts[j].classList.toggle('is-on', on);
        if (on) current = opts[j];
      }
      placeBlob(current);
      swapMoney(current);
    });
    if (qb) {
      qb.classList.add('is-ready');
      settleBlob();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(settleBlob);
      var ro = window.ResizeObserver ? new ResizeObserver(settleBlob) : null;
      if (ro) ro.observe(qb);
      window.addEventListener('resize', settleBlob);
      cleanups.push(function () { if (ro) ro.disconnect(); window.removeEventListener('resize', settleBlob); });
    }
    swapMoney(root.querySelector('.pdp__opt.is-on'));
  }

  /* Quick answers (Kamil 04.09): pill tabs, arrows, Home/End. */
  function initFaqTabs(root, cleanups) {
    var box = root.querySelector('[data-elora-pdp-faq]');
    if (!box) return;
    var list = box.querySelector('.pdp__ftabs');
    var tabs = Array.prototype.slice.call(box.querySelectorAll('.pdp__ftab'));
    var panels = Array.prototype.slice.call(box.querySelectorAll('.pdp__fpanel'));
    if (!list || !tabs.length || !panels.length) return;
    var cur = 1;

    function tabByN(n) {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('data-t') === String(n)) return tabs[i];
      }
      return null;
    }
    var goo = makeGoo(list, tabs, function () { return tabByN(cur); }, cleanups);

    function show(n, focus) {
      cur = n;
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-t') === String(n);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) tabs[i].focus();
      }
      for (var j = 0; j < panels.length; j++) {
        if (panels[j].getAttribute('data-p') === String(n)) {
          panels[j].removeAttribute('hidden');
        } else {
          panels[j].setAttribute('hidden', '');
        }
      }
      if (!focus) goo.settle(true);
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (tab) {
        tab.addEventListener('click', function () {
          show(parseInt(tab.getAttribute('data-t'), 10), false);
        });
        tab.addEventListener('keydown', function (e) {
          var k = e.key;
          var n = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') n = cur + 1 > tabs.length ? 1 : cur + 1;
          else if (k === 'ArrowLeft' || k === 'ArrowUp') n = cur - 1 < 1 ? tabs.length : cur - 1;
          else if (k === 'Home') n = 1;
          else if (k === 'End') n = tabs.length;
          if (n === null) return;
          e.preventDefault();
          show(n, true);
        });
      })(tabs[t]);
    }
    show(1, false);
  }

  NS.initPdp = function (scope) {
    var roots = (scope || document).querySelectorAll('[data-elora-pdp]');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      if (root.dataset.eloraPdpReady === '1') continue;
      root.dataset.eloraPdpReady = '1';
      var cleanups = [];
      initGallery(root, cleanups);
      initSpecline(root, cleanups);
      initOptions(root, cleanups);
      initFaqTabs(root, cleanups);
      root.eloraPdpTeardown = (function (el, callbacks) {
        return function () {
          callbacks.forEach(function (f) { f(); });
          delete el.dataset.eloraPdpReady;
        };
      })(root, cleanups);
    }
  };

  function boot() { NS.initPdp(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    NS.initPdp(e.target || document);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    var roots = e.target.querySelectorAll('[data-elora-pdp]');
    for (var r = 0; r < roots.length; r++) if (roots[r].eloraPdpTeardown) roots[r].eloraPdpTeardown();
  });
})();
